<template>
  <AdminDeviceDetailPage />
</template>

<script setup lang="ts">
import { useSeoMeta } from "@unhead/vue";
import AdminDeviceDetailPage from "shared-ui/pages/AdminDeviceDetailPage.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("device_inventory.title"),
});

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
